// Modal focus trap: prevents keyboard users from getting stuck in modals (WCAG 2.1.2)
$(function () {
  let modalTrigger = null;

  function trapFocus(e) {
    if (e.key !== 'Tab') return;

    const modal = document.querySelector('#modal');
    if (!modal) return;

    const focusable = modal.querySelectorAll(
      'button:not([disabled]), a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled])',
    );

    if (focusable.length === 0) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (e.shiftKey && document.activeElement === first) {
      last.focus();
      e.preventDefault();
    } else if (!e.shiftKey && document.activeElement === last) {
      first.focus();
      e.preventDefault();
    }
  }

  $('#modal').on('show.bs.modal', function (e) {
    const button = $(e.relatedTarget);
    if (button.length) modalTrigger = button[0];
    document.addEventListener('keydown', trapFocus);
  });

  $('#modal').on('hidden.bs.modal', function () {
    document.removeEventListener('keydown', trapFocus);
    if (modalTrigger) {
      modalTrigger.focus();
      modalTrigger = null;
    }
  });
});
